import { jsx as _jsx } from "react/jsx-runtime";
import { TextField } from "../text-field";
/**
 * A formik field for Social Security Number input.
 *
 * @param {TextFieldProps} props The props for the component.
 * @returns {JSX.Element} The rendered SSN field component.
 */
export const SSNField = ({ name, ...props }) => (_jsx(TextField, { ...props, name: name, format: "ssn", type: "tel" }));
